"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeStyle = function makeStyle() {
  return {
    Input: {
      '&.form-control[disabled]': {
        cursor: 'default !important'
      }
    },
    Italic: {
      '&::placeholder': {
        fontStyle: 'italic'
      },
      '&::-moz-placeholder': {
        fontStyle: 'italic'
      },
      '&::-webkit-input-placeholder': {
        fontStyle: 'italic'
      },
      '&:-ms-input-placeholder': {
        fontStyle: 'italic'
      },
      '&:-moz-placeholder': {
        fontStyle: 'italic'
      }
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map